import React from 'react';
import ScrollContainer from '../../Base/Components/ScrollContainer';
import styles from './WizardWrapper.module.scss';
import Wizard from './Wizard';
import { resolveWizardAction } from '../Services/wizard.service';

interface Props {
	wizardKey: string;
	initialData?: object;
}

const WizardWrapper: React.FC<Props> = ({ wizardKey, initialData }) => {
	return (
		<ScrollContainer>
			<div className={styles.wrapper}>
				<Wizard
					wizardKey={wizardKey}
					initialData={initialData}
					onWizardDone={resolveWizardAction}
				/>
			</div>
		</ScrollContainer>
	);
};

export default WizardWrapper;
